import newCollectionSlice from './newCollection-slice';
export const {
  setTotalCollected,
  setTotalTicketDispensed,
  setTotalTokenCollected,
  setCollectionCollected,
  setTransformedSublocations,
  setSummary,
  setTotalPrizeDispensed,
  setTotalMedallionDispensed,
  setFormikData,
  setIntercardData,
  setLocationCurrency,
  setSublocationDates,
  setSublocationAssets,
  setSubLocationDatesFormIsDirty,
  resetState,
  resetStateKeepIntercard,
  resetSubLocationDates,
  updateFormikData,
} = newCollectionSlice.actions;

export default newCollectionSlice;
